import { create } from 'zustand';

import type { BrowserAccount } from '@/services/auth/sessions';

export interface AccountContext {
    accountId: string;
    workspaceId?: string;
}

interface MultiAccountState {
    accounts: BrowserAccount[];
    context: AccountContext | null;
    mostRecentWorkspace: Required<AccountContext> | null;
    loading: boolean;
    switchingAccount: boolean;
    generation: number;
    error?: string;
    maxAccounts: number;
}

/** Account summaries live only in memory. The server's HttpOnly cookies remain the sole credentials. */
export const useMultiAccountStore = create<MultiAccountState>(() => ({
    accounts: [],
    context: null,
    mostRecentWorkspace: null,
    loading: true,
    switchingAccount: false,
    generation: 0,
    maxAccounts: 5,
}));

export function setAccountTransition(switchingAccount: boolean) {
    useMultiAccountStore.setState((state) => ({
        switchingAccount,
        generation: state.generation + 1,
        error: undefined,
    }));
}
